import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ReactNode } from 'react'

type ButtonProps = {
  text: ReactNode;
  onClick?: () => void
}
type StatProps = {
  buttonText?: ReactNode
  text: string
  number: number
  link?: string
  buttons?: ButtonProps[]
}

const Stats = ({ buttonText, text, number, link, buttons }: StatProps) => {
  const navigate = useNavigate()

  const createHandler = () => {
    if (!!link) navigate(link)
  }

  return (
    <Box>
      <Stack
        spacing={2}
        direction={window.innerWidth < 1024 ? 'column' : 'row'}
        sx={{
          mb: { xs: 3, sm: 0 },
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Paper elevation={2} sx={{ px: 5, py: 3, mb: 3 }}>
          <Box>
            <Typography variant='h6' fontWeight='Bold'>
              {text}
            </Typography>
          </Box>
          <Box>
            <Typography
              variant='h6'
              fontSize={'2.5rem'}
              fontWeight='Bold'
              color={'primary'}
            >
              {number}
            </Typography>
          </Box>
        </Paper>

        <Stack direction='row' spacing={2} sx={{ alignSelf: 'flex-start' }}>
          {!!link ? (
            <Button
              onClick={createHandler}
              style={{
                height: '45px',
              }}
              sx={{ color: 'white' }}
              variant='contained'
            >
              {buttonText}
            </Button>
          ) : null}
          {buttons?.map((button) => (
            <Button
              key={button.text?.toString()}
              onClick={button.onClick}
              variant='contained'
              sx={{ color: 'white', height: '45px' }}
            >
              {button.text}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Box>
  )
}

export default Stats
